// extracted by mini-css-extract-plugin
module.exports = {"content":"partner_content__Ezm8_"};